(function($) {

	$('#slide-button').click(function(e){
    e.preventDefault();
    $('.term-description').toggleClass('active-term');
    $('#slide-button').toggleClass('active-button');
  });



})(jQuery);